/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsExchanger: {
  name: 'exchanger';
  data: string;
} = {
  name: 'exchanger',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 3a1 1 0 1 0-2 0v1H9a2 2 0 0 0-2 2H5V3a1 1 0 0 0-2 0V20H2a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2h-1V3Zm-2 3H9v2h6a2 2 0 0 1 2 2h2V6Zm-2 6a2 2 0 0 1-2 2H9v2h6a2 2 0 0 1 2 2v2h2v-8h-2Zm-2 8v-2H9a2 2 0 0 1-2-2H5v4h10Zm-8-6a2 2 0 0 1 2-2h6v-2H9a2 2 0 0 1-2-2H5v6h2Z" fill="currentColor"/></svg>`,
};
